import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);

import { FormValidator } from '@utils/forms.js';
import FlipButton from '../snippets/flipbutton';

export default class ShareYourWorkForm {
  constructor(container) {
    this.container = container;
    this.form = container.querySelector('form');
    this.title = container.querySelector('.syw-form__title');

    this.animateTitle();
    this.animateGroupLabels();
    this.animateItems();

    if (!this.form) return;

    this.validator = new FormValidator(this.form, {
      ajax: true,
      successSelector: '.syw-form__notice--success',
      errorSelector: '.syw-form__notice--error',
    });
    this.validator.init();

    this.bindRadioToTextarea();
    this.initSubmitFlip();
    this.scrollToNoticeIfPresent();
  }

  initSubmitFlip() {
    const label = this.form.querySelector('.syw-form__submit .js-flipbutton');
    if (label) new FlipButton(label, { fade: false });
  }

  animateTitle() {
    if (!this.title) return;
    const textLines = new SplitText(this.title, { type: 'lines,words', linesClass: 'lineParent' });
    gsap.fromTo(
      textLines.words,
      { yPercent: 100 },
      {
        yPercent: 0,
        duration: 0.6,
        stagger: { each: 0.1, ease: 'power.out', from: 'start' },
        ease: 'power3.out',
        scrollTrigger: { trigger: this.title, start: 'top 85%' },
      }
    );
  }

  animateGroupLabels() {
    const labels = gsap.utils.toArray('.syw-form__group-label', this.container);
    if (!labels.length) return;
    gsap.set(labels, { opacity: 0, x: -40 });

    ScrollTrigger.batch(labels, {
      start: 'top 88%',
      onEnter: (els) =>
        gsap.to(els, { opacity: 1, x: 0, duration: 1, stagger: 0.1, ease: 'power2.out' }),
    });

  }

  animateItems() {
    const items = gsap.utils.toArray('.syw-form__card, .syw-form__consent, .syw-form__submit', this.container);
    if (!items.length) return;
    gsap.set(items, { opacity: 0, y: 30 });
    ScrollTrigger.batch(items, {
      start: 'top 88%',
      onEnter: (els) =>
        gsap.to(
          els,
          { opacity: 1, y: 0, duration: 1, stagger: 0.1, ease: 'power2.out' }
        ),
    });
  }

  bindRadioToTextarea() {
    const radios = this.form.querySelectorAll('input[name="contact[interest]"]');
    const textarea = this.form.querySelector('textarea[name="contact[interest_other]"]');
    if (!textarea || radios.length === 0) return;

    const sync = () => {
      const otherRadio = this.form.querySelector('input[name="contact[interest]"][data-interest="other"]');
      const isOther = otherRadio && otherRadio.checked;
      textarea.disabled = !isOther;
      textarea.parentElement.style.opacity = isOther ? '1' : '0.45';
    };

    radios.forEach((radio) => radio.addEventListener('change', sync));
    sync();
  }

  scrollToNoticeIfPresent() {
    const notice = this.container.querySelector('.syw-form__notice');
    if (!notice) return;
    requestAnimationFrame(() => {
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(notice, { offset: -80, duration: 1.0 });
      } else {
        notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
}
